import React from "react";
import { Pagination } from "antd";
import ProductCard from "../ProductCard";
import {
  MainContainer,
  HeaderRow,
  StyledHeading,
  SearchWrap,
  SearchInput,
  InnerContainer,
  PaginationWrapper,
} from "./styles";

const ProductSection = ({
  heading,
  products,
  currentPage,
  total,
  pageSize = 10,
  onPageChange,
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search products...",
}) => {
  return (
    <MainContainer>
      <HeaderRow>
        <StyledHeading>{heading}</StyledHeading>
        {onSearchChange ? (
          <SearchWrap>
            <SearchInput
              type="search"
              placeholder={searchPlaceholder}
              value={searchValue ?? ""}
              onChange={(e) => onSearchChange(e.target.value)}
              aria-label={searchPlaceholder}
            />
          </SearchWrap>
        ) : null}
      </HeaderRow>
      <InnerContainer>
        {products?.length ? (
          products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))
        ) : (
          <p style={{ width: "100%", textAlign: "center", color: "#6b7280" }}>
            No products found.
          </p>
        )}
      </InnerContainer>
      <PaginationWrapper>
        <Pagination
          current={currentPage}
          total={total || 0}
          pageSize={pageSize}
          onChange={onPageChange}
          onShowSizeChange={onPageChange}
        />
      </PaginationWrapper>
    </MainContainer>
  );
};

export default ProductSection;
